import {
  Box,
  Button,
  Flex,
  Heading,
  StackDivider,
  Text,
  VStack
} from '@chakra-ui/react'
import { IntakeQuestionnaireModal } from '@containers/intake-questionnaire-modal'
import { DischargeSummary, TreatmentPlan } from '@handlers/sessions/components'
import { useExperienceManager } from '@hooks'
import React, { useState } from 'react'
import {
  usePatientControllerGetIntakeConsentResults,
  usePatientControllerGetIntakeQuestionnaireResults,
  usePatientControllerGetIntakeStatus
} from '~/clinician-api'

import { ConsentedPolicyItem } from './components/consented-policy-item'

const Documents = (props: any) => {
  const { patient } = props
  const { isProPlanEnabled } = useExperienceManager()

  const [isIntakeQuestionnaireModalOpen, setIsIntakeQuestionnaireModalOpen] =
    useState(false)

  const { data: intakeConsentResults } =
    usePatientControllerGetIntakeConsentResults(patient.id, {
      query: {
        enabled: isProPlanEnabled
      }
    })
  const { data: result } = usePatientControllerGetIntakeQuestionnaireResults(
    patient.id,
    {
      query: {
        enabled: isProPlanEnabled
      }
    }
  )
  const { data: intakeStatus } = usePatientControllerGetIntakeStatus(
    patient.id,
    {
      query: {
        enabled: isProPlanEnabled
      }
    }
  )

  return (
    <>
      <Box>
        <Heading size="lg" mb="medium">
          Care-related
        </Heading>
      </Box>
      {intakeStatus?.status === 'completed' && (
        <VStack
          border="1px solid"
          flex="1"
          borderColor="pale_gray"
          borderRadius="8px"
          p="16px"
          boxShadow="0px 2px 8px 0px #00000014"
          alignItems="stretch"
          mb="large"
        >
          <Flex gap="8px" w="100%">
            <Flex>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 16H16V18H8V16ZM8 12H16V14H8V12ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
                  fill="#2D54E8"
                />
              </svg>
            </Flex>
            <Flex flexDirection="column">
              <Text fontWeight="bold">Intake Questionnaire</Text>
              <Text lineHeight="17px" fontSize="13px" color="dark_gray">
                Completed at{' '}
                {result?.completedDate
                  ? new Date(
                      result.completedDate as string
                    ).toLocaleDateString()
                  : '--'}
              </Text>
            </Flex>
          </Flex>
          <Button
            variant="outline"
            w="full"
            borderRadius="4px"
            mt="8px"
            size="sm"
            onClick={() => setIsIntakeQuestionnaireModalOpen(true)}
            data-click-text="View Intake Questionnaire Results"
          >
            View Results
          </Button>
        </VStack>
      )}
      <TreatmentPlan
        client={patient}
        containerProps={{ spacing: 4 }}
        emptyStateText="Integrate a treatment plan into future notes for golden thread documentation."
      />
      <Box h="24px" />
      <DischargeSummary client={patient} />
      {intakeStatus?.status === 'completed' && (
        <>
          {intakeConsentResults?.policies && (
            <Box>
              <Heading size="lg" mb="medium" mt="small">
                Policy
              </Heading>
              <VStack
                border="1px solid"
                borderColor="gray.300"
                borderRadius="md"
                spacing="0px"
                align="flex-start"
                divider={
                  <StackDivider
                    borderBottom="1px solid"
                    borderBottomColor="pale_gray"
                  />
                }
              >
                {intakeConsentResults?.policies?.map(policy => {
                  return (
                    <ConsentedPolicyItem
                      key={policy.documentReference.id}
                      consentItem={policy}
                    />
                  )
                })}
              </VStack>
            </Box>
          )}
          <IntakeQuestionnaireModal
            patientId={patient.id}
            isOpen={isIntakeQuestionnaireModalOpen}
            onClose={() => setIsIntakeQuestionnaireModalOpen(false)}
          />
        </>
      )}
    </>
  )
}

export default Documents
